export default function countdownStrip() {
	var modalContainer = $('.modal-container');

	if ($(modalContainer).length > 0) {
		modalContainer.each(function() {
			var thisImg = $(this).closest('.image-text-col-row').find('.has-video'),
					thisContainer = $(this),
					thisVideo = thisContainer.find('iframe');

			// support for Slider block
			if (thisImg.length == 0 && thisContainer.hasClass('slider-modal')) {
				var thisModal = $(this).data('video-modal'),
						thisContentCTA = $('.slider-slide').find('.slide-content[data-video-modal="'+ thisModal +'"] a.cta');
				
				thisImg = $('.slider-slide').find('.image-block[data-video-modal="'+ thisModal +'"]');
			
				thisContentCTA.on('click', function(e) {
					e.preventDefault();
					// if video src is empty, populate it again
		      if (thisVideo.attr('src') == ''){
		        var datasrc = thisVideo.attr('data-src');
		        thisVideo.attr('src', datasrc);
		      }
		      $(thisContainer).addClass('active');
				});
			}

	    // click image to open modal
	    thisImg.on('click',function(){
	    	// if video src is empty, populate it again
	      if (thisVideo.attr('src') == ''){
	        var datasrc = thisVideo.attr('data-src');
	        thisVideo.attr('src', datasrc);
	      }
	      $(thisContainer).addClass('active');
	    });

	    // click anywhere in modal (not iframe) to close modal
	    thisContainer.on('click',function(e){
	      // turn off the youtubes
	      // https://developers.google.com/youtube/iframe_api_reference
	      thisContainer.removeClass('active');
	      var src = thisVideo.attr('src');
	      thisVideo.attr('src','').attr('data-src', src);
	    });

	    // if iframe-fluid is empty, user hasn't consented to cookies
	    // show notice instead
	    if (thisContainer.find('.iframe-fluid')) {
	    	var iframeEl = thisContainer.find('.iframe-fluid');
		    if (iframeEl.children().length == 0) {
			    iframeEl.append('<div class="consent-required-notice">Please accept cookies to access this content</div>');
		    }
	    }
		});
	}
};